export const AULA_URLS = {
  INFO: 'https://aulainfo.dk/',
  OPERATING_STATUS: 'https://aulainfo.dk/driftsstatus',
  ACCESSIBILITY_STATEMENT: 'https://www.was.digst.dk/aula-dk',
} as const;
